import Vue from 'vue'
import Vuex from 'vuex'
import createPersist from 'vuex-localstorage'

Vue.use(Vuex)

// Vue design components
import Vuetify from 'vuetify'
Vue.use(Vuetify, {
  iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
})

// Modules
import auth from './modules/auth'
import util from './modules/util'
import contractBuild from './modules/contractBuild'
import contractsDb from './modules/contractsDb'
import eosJsFunc from './modules/eosJsFunc'
import scatterFunc from './modules/scatterFunc'
import payments from './modules/payments'
import smartcheck from './modules/smartcheck'
 

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
    modules: {
        auth,
        util,
        contractBuild,
        contractsDb,
        eosJsFunc,
        scatterFunc,
        payments,
        smartcheck,
 
    },
    strict: debug,
    plugins: [createPersist({
        namespace: 'smartpress-web-platform',
        initialState: {a:'s'},
        // ONE_WEEK
        expires: 7 * 24 * 60 * 60 * 1e3
    })]
})

export default store